
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import SearchPage from './pages/SearchPage';

function SearchEngine() {
  return (
    <div className="app">

            <Home />
       </div>
  );
}

export default SearchEngine;
